import React from "react";
import { useRef } from "react";
import "./Join.css";
import emailjs from '@emailjs/browser';
export const Join = () => {
    const form = useRef()
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_s1dvddi', 'template_uovqfqt', form.current, 'DSfHDD1Z57EKtuDuL')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
            
          <span className="stroke-text">Ready to </span>
          <span>level up </span>
        </div>
        <div>
          <span>your business </span>
          <span className="stroke-text">with us?</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} className="email-container" onClick={sendEmail}>
            <input type="email" name="user_email" id="" placeholder="Enter your email adress here..."/>
            <button className="btn btn-j">Book Now</button>
        </form>
      </div>
    </div>
  );
};
